var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20711 8.29289C0.816583 8.68342 0.816583 9.31658 1.20711 9.70711L8.43123 16.9312C8.74616 17.2462 9.25607 17.2484 9.57378 16.9363V16.9363C9.89549 16.6202 9.89779 16.1025 9.57888 15.7836L3.60781 9.8125L17.6875 9.8125C18.1362 9.8125 18.5 9.44873 18.5 9V9C18.5 8.55127 18.1362 8.1875 17.6875 8.1875L3.60781 8.1875L9.57888 2.21643C9.89779 1.89753 9.89549 1.37978 9.57378 1.06372V1.06372C9.25607 0.751581 8.74616 0.753837 8.43123 1.06877L1.20711 8.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.63341dac95af480994ed712b4949e2a2.svg";
export { ForwardRef as ReactComponent };